const resetApp = () => ({
  type: 'RESET_APP',
});

export default resetApp;
